import { render, staticRenderFns } from "./OrdersInCourse.vue?vue&type=template&id=67636dd0&scoped=true&"
import script from "./OrdersInCourse.vue?vue&type=script&lang=js&"
export * from "./OrdersInCourse.vue?vue&type=script&lang=js&"
import style0 from "./OrdersInCourse.vue?vue&type=style&index=0&id=67636dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67636dd0",
  null
  
)

export default component.exports